import { render, staticRenderFns, recyclableRender, components } from "./u-skeleton.vue?vue&type=template&id=d0b470f2&scoped=true&"
var renderjs
import script from "./u-skeleton.vue?vue&type=script&lang=js&"
export * from "./u-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./u-skeleton.vue?vue&type=style&index=0&id=d0b470f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b470f2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-skeleton/u-skeleton.vue"
export default component.exports